import unified from 'unified';
import markdown from 'remark-parse';
import remarkToRehype from 'remark-rehype';
import raw from 'rehype-raw';
import sanitize from 'rehype-sanitize';
import prism from '@mapbox/rehype-prism';
import html from 'rehype-stringify';
// https://github.com/syntax-tree/hast-util-sanitize/blob/master/lib/github.json
import githubSchema from 'hast-util-sanitize/lib/github';
import docs from './rehype-docs';
import {replaceVideo} from "./utils";


export const GITHUB_URL = 'https://github.com';

export const RAW_GITHUB_URL = 'https://raw.githubusercontent.com';

export const REPO_NAME = 'betterbook-io/docs';

export const REPO_BRANCH = 'master';


// Allow className for all elements
githubSchema.attributes['*'].push('className');

const handlers = {
    // Add a className to inlineCode so we can differentiate between it and code fragments
    inlineCode(h, node) {
        return {
            ...node,
            type: 'element',
            tagName: 'code',
            properties: {className: 'inline'},
            children: [
                {
                    type: 'text',
                    value: node.value,
                },
            ],
        };
    },
};

// Create the processor, the order of the plugins is important
const getProcessor = unified()
    .use(markdown)
    .use(remarkToRehype, {handlers, allowDangerousHtml: true})
    // Add custom HTML found in the markdown file to the AST
    .use(raw)
    // Sanitize the HTML
    .use(sanitize, githubSchema)
    // Add syntax highlighting to the sanitized HTML
    .use(prism)
    .use(html)
    .freeze();

export function getIndicesOf(searchStr, str) {
    var searchStrLen = searchStr.length;
    if (searchStrLen === 0) {
        return [];
    }
    var startIndex = 0, index, indices = [];
    str = str.toLowerCase();
    searchStr = searchStr.toLowerCase();

    while ((index = str.indexOf(searchStr, startIndex)) > -1) {
        indices.push(index);
        startIndex = index + searchStrLen;
    }
    return indices;
}

export async function mdToHtml(md) {
    try {
        // Init the processor with our custom plugin
        const processor = getProcessor();
        const file = await processor.process(md);

        //[[ embed url=https://youtu.be/iEPTlhBmwRg ]]
        const idxs = getIndicesOf('[[ embed url=', file.contents);
        const exdIdxs = getIndicesOf(' ]]', file.contents);
        let cnt = 0;
        for (let k = 0; k < idxs.length; k++) {
            const substr = file.contents.substr(idxs[k], exdIdxs[k]);
            const link = file.contents.substr(idxs[k] + 13, exdIdxs[k]);
            const h = `
                <figure class="video_container">
                  <iframe src="${link}" frameborder="0" allowfullscreen="true"> </iframe>
                </figure>
            `;
            file.contents.replace(substr, h);
        }

        // Replace non-breaking spaces (char code 160) with normal spaces to avoid style issues
        return replaceVideo(file.contents.replace(/\xA0/g, ' '));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Markdown to HTML error: ${error}`);
        throw error;
    }
}

export default async function markdownToHtml(filePath, md) {
    try {
        const repoUrl = `${GITHUB_URL}/${REPO_NAME}/blob/${REPO_BRANCH}`;
        // Init the processor with our custom plugin
        const processor = getProcessor().use(docs, {filePath, repoUrl});
        const file = await processor.process(md);

        // Replace non-breaking spaces (char code 160) with normal spaces to avoid style issues
        return file.contents.replace(/\xA0/g, ' ');
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Markdown to HTML error: ${error}`);
        throw error;
    }
}
